import React from 'react'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import { Box } from '@mantine/core';
import { addDays, subDays } from 'date-fns';
import { useState } from 'react';

const OBRCDateRangePicker = ({ onDateSelect, initialStartDate, initialEndDate }) => {
  const [dates, setDates] = useState([
    {
      startDate: initialStartDate,
      endDate: initialEndDate,
      key: 'selection'
    }
  ]);

  const onHandleDateChange = (item) => {
    setDates([item.selection]);
    onDateSelect([item.selection]);
  }

  return (
    <Box>
      <DateRange 
        onChange={onHandleDateChange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={1}
        direction='horizontal'
        preventSnapRefocus={true}
        ranges={dates}
        calendarFocus='backwards'
      />
    </Box>
  )
}

export default OBRCDateRangePicker;